import { IonAlert, IonIcon } from '@ionic/react'
import { logOutOutline } from 'ionicons/icons'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { UserContext } from '../contexts/UserContext'

const LogoutButton = () => {
	const { logOut } = useContext(UserContext)
	const [showAlert, setShowAlert] = useState(false)
	const { t } = useTranslation('common')

	return (
		<>
			<div className='userData-logout mt-6 rounded-full py-2 px-4 bg-[#f5f5f5] dark:bg-[#031f22] hover'>
				<IonIcon
					icon={logOutOutline}
					className='logOutIcon text-brand-primary-100-light dark:text-brand-primary-100-dark'
				/>
				<span
					className='text-brand-primary-100-light dark:text-brand-primary-100-dark'
					onClick={() => setShowAlert(true)}
				>
					{t('logout')}
				</span>
			</div>

			<IonAlert
				isOpen={showAlert}
				onDidDismiss={() => setShowAlert(false)}
				header={t('reallyLogout')}
				message=''
				buttons={[
					{
						text: t('kylla'),
						handler: () => {
							setShowAlert(false)
							logOut()
						},
					},
					{
						text: t('ei'),
						role: 'cancel',
						handler: () => {
							setShowAlert(false)
						},
					},
				]}
			/>
		</>
	)
}
export default LogoutButton
